import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Dashboard from './Component/Dashboard';
import Create from './Component/Create';
import Create_Projects from './Component/Create_Projects';
import Create_Todo from './Component/Create_Todo';
import Add_task from './Component/Add_task';
import UserProfile from './Component/UserProfile';
import Manage_team from './Component/Manage_team';
import Redirect_mkanage_team from './Component/Redirect_mkanage_team';
import Signin from './Component/Signin';
import Projectlist from './Component/Projectlist';
import Project_details from './Component/Project_details';
import Task_management from './Component/Task_management';
import RemoveMemList from './Component/RemoveMemList';
import Test from './Component/Test';
import Redirect_task_mang from './Component/Redirect_task_mang';
import Task_details from './Component/Task_details';
import Add_member from './Component/Add_member';
import Signup from './Component/Signup';
import Redirect_tsk_details from './Component/Redirect_tsk_details';
import RedirectProjectList from './Component/RedirectProjectList';
import Redirect_member_list from './Component/Redirect_member_list';
import Completetask_details from './Component/Completetask_details';
import Member_Projectlist from './Component/Member_Projectlist';
import Companymemberpage from './Component/Companymemberpage';
import Redirect_team from './Component/Redirect_team';
import Member_details from './Component/Member_details';
import Complete_projects from './Component/Complete_projects';
import Re_complete_projectlist from './Component/Re_complete_projectlist';
import Complete_projectDetails from './Component/Complete_projectDetails';
import Member_complete_project from './Component/Member_complete_project';
import My_task from './Component/My_task';
import Redirect_mytask from './Component/Redirect_mytask';
import Admin_mytask from './Component/Admin_mytask';
import Logout from './Component/Logout';
import Create_new_task from './Component/Create_new_task';
import Reload_create_task from './Component/Reload_create_task';
import Member_create_task from './Component/Member_create_task';
import Reload_member_create_task from './Component/Reload_member_create_task';
import Company_settings from './Component/Company_settings';
import Redirect_setting from './Component/Redirect_setting';
import Loglist from './Component/Loglist';
import Time_tracker from './Component/Time_tracker';
import My_worklist from './Component/My_worklist';
import My_activity from './Component/My_activity';
import Company_member_Timetrack from './Component/Company_member_Timetrack';
import Member_daily_report from './Component/Member_daily_report';
import Report_inbox from './Component/Report_inbox';
import Report_history from './Component/Report_history';
import Create_goal from './Component/Create_goal';
import Goal_list from './Component/Goal_list';
import Redirect_goallist from './Component/Redirect_goallist';
import Goal_details from './Component/Goal_details';
import Edithgoal from './Component/Edithgoal';
import Notification_inbox from './Component/Notification_inbox';
import Notification from './Component/Notification';
import Archive_notification from './Component/Archive_notification';
import Role_permission from './Component/Role_permission';
import Communication from './Component/Communication';
import Email_template from './Component/Email_template';
import Redirect_invitation from './Component/Redirect_invitation';
import Project_insight from './Component/Project_insight';
import Meeting_room from './Component/Meeting_room';
import Timesheet from './Component/Timesheet';
import My_timesheet from './Component/My_timesheet';
import Worklog from './Component/Worklog';
import Bilable_hours from './Component/Bilable_hours';
import My_worklog from './Component/My_worklog';
import Invoicelist from './Component/Invoicelist';
import User_management from './Component/User_management';
import Cancel_account from './Component/Cancel_account';
import Redirect_usaersetting from './Component/Redirect_usaersetting';
import Review from './Component/Review';
import Landing from './Component/Landing';
import Intermideat from './Component/Intermideat';
import Forgotpassword from './Component/Forgotpassword';



function App() {
  return (
    <section className='singleheight'>
    <Router basename="/">     
    <div className='fullwidth'>         
      <Routes>       
      <Route exact path="/landing" element={<Dashboard/>} />
      <Route exact path="/" element={<Signin/>} />
      <Route exact path="/create" element={<Create/>} />
      <Route exact path="/create_projects" element={<Create_Projects/>} />
      <Route exact path="/create_todo" element={<Create_Todo/>} />
      <Route exact path="/add_task" element={<Add_task/>} />
      <Route exact path="/userprofile" element={<UserProfile/>} />
      <Route exact path="/manage_team" element={<Manage_team/>} />
      <Route exact path="/redirect_manage_tool" element={<Redirect_mkanage_team/>} />
      <Route exact path="/projectlist" element={<Projectlist/>} />
      <Route exact path="/project_details" element={<Project_details/>} />
      <Route exact path="/task_management" element={<Task_management/>} />
      <Route exact path="/remove_mem" element={<RemoveMemList/>} />
      <Route exact path="/redirect_task" element={<Redirect_task_mang/>} />
      <Route exact path="/task_details" element={<Task_details/>} />
      <Route exact path="/add_member" element={<Add_member/>} />
      <Route exact path="/signup" element={<Signup/>} />
      <Route exact path="/re_tskdetails" element={<Redirect_tsk_details/>} />
      <Route exact path="/re_procectlist" element={<RedirectProjectList/>} />
      <Route exact path="/reloadMemList" element={<Redirect_member_list/>} />
      <Route exact path="/completetask_details" element={<Completetask_details/>} />
      <Route exact path="/member_projectlist" element={<Member_Projectlist/>} />
      <Route exact path="/companymember_list" element={<Companymemberpage/>} />
      <Route exact path="/redirect_team" element={<Redirect_team/>} />
      <Route exact path="/member_details" element={<Member_details/>} />
      <Route exact path="/complete_projects" element={<Complete_projects/>} />
      <Route exact path="/re_complete_procectlist" element={<Re_complete_projectlist/>} />
      <Route exact path="/complete_project_details" element={<Complete_projectDetails/>} />
      <Route exact path="/member_complete_projects" element={<Member_complete_project/>} />
      <Route exact path="/my_task" element={<My_task/>} />
      <Route exact path="/redirect_mytask" element={<Redirect_mytask/>} />
      <Route exact path="/admin_mytask" element={<Admin_mytask/>} />
      <Route exact path="/logout" element={<Logout/>} />
      <Route exact path="/create_task" element={<Create_new_task/>} />
      <Route exact path="/reload_create_task" element={<Reload_create_task/>} />
      <Route exact path="/member_create_task" element={<Member_create_task/>} />
      <Route exact path="/reload_member_create_task" element={<Reload_member_create_task/>} />
      <Route exact path="/company_setting" element={<Company_settings/>} />
      <Route exact path="/redirect_settings" element={<Redirect_setting/>} />
      <Route exact path="/loglist" element={<Loglist/>} />
      <Route exact path="/time_tracker" element={<Time_tracker/>} />
      <Route exact path="/my_workhistory" element={<My_worklist/>} />
      <Route exact path="/my_activity" element={<My_activity/>} />
      <Route exact path="/company_member_timetrack" element={<Company_member_Timetrack/>} />
      <Route exact path="/member_daily_report" element={<Member_daily_report/>} />
      <Route exact path="/report_inbox" element={<Report_inbox/>} />
      <Route exact path="/report_history" element={<Report_history/>} />
      <Route exact path="/create_goal" element={<Create_goal/>} />
      <Route exact path="/goals" element={<Goal_list/>} />
      <Route exact path="/re_goallist" element={<Redirect_goallist/>} />
      <Route exact path="/goal_details" element={<Goal_details/>} />
      <Route exact path="/edit_goal" element={<Edithgoal/>} />
      <Route exact path="/inbox" element={<Notification_inbox/>} />
      <Route exact path="/notification" element={<Notification/>} />
      <Route exact path="/archive_notification" element={<Archive_notification/>} />
      <Route exact path="/role_permission" element={<Role_permission/>} />
      <Route exact path="/communications" element={<Communication/>} />
      <Route exact path="/email_template" element={<Email_template/>} />
      <Route exact path="/redirect_communications" element={<Redirect_invitation/>} />
      <Route exact path="/project_insight" element={<Project_insight/>} />
      <Route exact path="/meeting_room" element={<Meeting_room/>} />
      <Route exact path="/timesheet" element={<Timesheet/>} />
      <Route exact path="/my_timesheet" element={<My_timesheet/>} />
      <Route exact path="/worklog" element={<Worklog/>} />
      <Route exact path="/bilable_hours" element={<Bilable_hours/>} />
      <Route exact path="/my_worklog" element={<My_worklog/>} />
      <Route exact path="/invoicelist" element={<Invoicelist/>} />
      <Route exact path="/user_management" element={<User_management/>} />
      <Route exact path="/cancel_account" element={<Cancel_account/>} />
      <Route exact path="/redirect_usersetting" element={<Redirect_usaersetting/>} />
      <Route exact path="/review" element={<Review/>} />
      <Route exact path="/dashboard" element={<Landing/>} />
      <Route exact path="/intermideat" element={<Intermideat/>} />
      <Route exact path="/forgotpass" element={<Forgotpassword/>} />
      




      
      </Routes>  

    </div>
    </Router>
  </section>
  );
}

export default App;
